import React from 'react';
import { BarberLanding } from './pages/BarberLanding';
export function App() {
  return <>
      <div className="barber-pole-left" data-id="element-0" />
      <div className="barber-pole-right" data-id="element-1" />
      <BarberLanding data-id="element-2" />
    </>;
}